import { createBrowserHistory as createHistory } from 'history';

import { isClient } from "../../../../../helpers";

const updateHistory = (qsa, props) => {
    if (isClient()) {
        const history = createHistory();
        const { location } = props;
        const pathname = location ? location.pathname : '';

        history.push({
            pathname,
            search: qsa,
        });

    }
}

export default updateHistory;